export default __webpack_public_path__ + "static/media/businesscore1.66d3d749.jpeg";